/* eslint-disable jsx-a11y/anchor-is-valid */
// @flow
import React, { useState, useEffect } from 'react';
// components
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getAlertLive, getUserRequestAPI } from '../../API/RDPMS_API';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { alertLiveColumns, mapRequestDataToOptions, sizePerPageList } from './requestDataMapper';
import AlertFeedbackModal from '../../components/modal/AlertFeedbackModal';
import { Row, Col, Modal } from 'react-bootstrap';

const AlertLive = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    const userRole = auth?.user?.role;

    const [notificationData, setNotificationData] = useState();
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(true);

    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const [predectiveCount, setPredectiveCount] = useState(0);
    const [failureCount, setFailureCount] = useState(0);
    const [totalsCount, setTotalsCount] = useState(0);

    const [selectedZones, setSelectedZones] = useState([]);
    const [selectedDivisions, setSelectedDivisions] = useState([]);
    const [selectedStation, setSelectedStation] = useState([]);
    const [selectedAssetsType, setSelectedAssetsType] = useState([]);

    const [selectedAlertType, setSelectedAlertType] = useState([]);

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [assetsTypeCode, setAssetsTypeCode] = useState([]);
    const [assetsType, setAssetsType] = useState([]);
    const [assetsNumber, setAssetsNumber] = useState([]);
    const [alertType, setAlertType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
        {
            label: 'Failure',
            value: 'FLR',
        },
        {
            label: 'Success',
            value: 'SUC',
        },
    ]);

    const [statusMessage, setStatusMessage] = useState('');
    // useEffect(() => {
    //     getAlertDetailsData(limit, pageNumber);
    //     const fetchStation = async () => {
    //         await getRequestData(auth.user._id);
    //     };

    //     fetchStation();
    // }, []);

    useEffect(() => {
        const fetchStation = async () => {
            await getRequestData(auth.user._id);
        };

        fetchStation();
    }, []);

    useEffect(() => {
        if (stations && stations.length > 0) {
            getAlertDetailsData(limit, pageNumber);
        }
    }, [stations]);

    const { t } = useTranslation();

    const handleFeedbackClick = (data) => {
        // console.log('Clicked Feedback:', data.notification);

        setShowFeedbackModal(true);
        setSelectedStatus(data.status);
        setNotificationData(data.notification);
    };

    const getAlertDetailsData = async (limits, pages) => {
        Loading();
        // console.log(stations, 'stations.....');
        // console.log(selectedStation, 'selectedStation.....');

        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        // const station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        // console.log(station, 'station.....');

        let station = [];
        if (userRole === 'super admin') {
            // Existing logic
            station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        } else {
            //  user station select
            if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
                station = selectedStation.map((s) => s.value);
            } else {
                // not select station select  → get stations state
                station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
            }
        }

        const assetsType = selectedAssetsType.some((a) => a.value === 'all')
            ? []
            : selectedAssetsType.map((a) => a.value);

        const alertType = selectedAlertType.some((a) => a.value === 'all') ? [] : selectedAlertType.map((a) => a.value);

        let request = {
            zone: zone,
            division: division,
            station: station,
            asset_type: assetsType,
            alert_type: alertType,

            page_number: pagesNumber,
            page_size: limitNumber,
        };

        // console.log(request, 'request.........');

        let response = await getAlertLive(request);
        // console.log(response, 'response.........');

        if (response) {
            let srNo = pagesNumber * limitNumber - limitNumber + 1;
            let dataArray = [];

            setPredectiveCount(0);
            setFailureCount(response?.failureCount || 0);
            setTotalsCount(response?.totalCount || 0);

            response?.zone?.forEach((z) => {
                z.division?.forEach((d) => {
                    d.station?.forEach((s) => {
                        s.alert_type?.forEach((at) => {
                            at.asset_type?.forEach((ast) => {
                                ast.asset_number?.forEach((asn) => {
                                    const note = asn.notification || {};

                                    dataArray.push({
                                        srNo: srNo++,

                                        zoneCode: z.zc || '',
                                        divisionCode: d.dc || '',
                                        stationCode: s.sc || '',

                                        alertType: at.alert_type_code || '',
                                        assetType: ast.astc || '',
                                        assetNumber: asn.asnc || '',

                                        causeCode: note.cause_code || 'NA',

                                        incidenceDate: asn.incidence_date_time || '',
                                        rectificationDate: asn.rectification_date_time || '',
                                        incidenceDuration: asn.incidence_duration || '',

                                        // FEEDBACK UI SAME RAKHA HAI
                                        feedbackRemarks: (
                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    {['T', 'PT', 'F', 'M'].map((status) => {
                                                        const isAllowed =
                                                            userRole === 'super admin' ||
                                                            userRole === 'admin' ||
                                                            userRole === 'Maintainer';

                                                        return (
                                                            <div
                                                                key={status}
                                                                style={{
                                                                    border: '3px solid black',
                                                                    borderRadius: '10px',
                                                                    width: '40px',
                                                                    height: '40px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: isAllowed ? 'pointer' : 'not-allowed',
                                                                    fontWeight: '600',
                                                                    opacity: isAllowed ? 1 : 0.5,
                                                                }}
                                                                onClick={() => {
                                                                    if (!isAllowed) return;

                                                                    handleFeedbackClick({
                                                                        status,
                                                                        notification: note,
                                                                    });
                                                                }}>
                                                                {status}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ),
                                    });
                                });
                            });
                        });
                    });
                });
            });

            setPageNumber(response.currentPage);
            setPageCount(response.totalPages);
            setData(dataArray);
            setTotalCount(response.totalCount);

            setStatusMessage('Alerts details fetched successfully');
        }
        Loading();
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);
            // console.log(response, 'getUserRequestAPI response....');

            if (response) {
                const { stations, zones, divisions, assetsTypeCode, assetsType, assetsNumber, causes } =
                    mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
                setAssetsTypeCode(assetsTypeCode);
                setAssetsType(assetsType);
                setAssetsNumber(assetsNumber);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAlertDetailsData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAlertDetailsData(limit, value);
    };

    const feedbackCloseModalWithHeaderClass = () => {
        getAlertDetailsData(limit, pageNumber);
        setShowFeedbackModal(false);
    };

    return (
        <>
            <ToastContainer />

            <div className=" py-1 " style={{ width: '100%' }}>
                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        {/* Alerts Overview Button */}
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Alert Live
                            </button>
                        </div>

                        {/* Dropdown and Update Button */}
                        {/* <div className="col-12 col-md-auto ms-md-auto">
                            <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-5">
                               
                                <button
                                    className="update d-flex align-items-center justify-content-center flex-grow-1"
                                    id="update">
                                    Update <i className="mdi mdi-autorenew ms-1"></i>
                                </button>
                            </div>
                        </div> */}
                    </div>
                </div>

                <div
                    className="report-alert-card my-2 p-1"
                    style={{
                        width: '100%',
                        boxShadow: ' 0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    <div className="container form-container justify-content-center">
                        <form>
                            <div className="row d-flex flex-center">
                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="Assets Type"
                                    id="assetsSelect"
                                    options={assetsType}
                                    selectedValues={selectedAssetsType}
                                    onChange={setSelectedAssetsType}
                                />

                                <MultiSelectDropdown
                                    label="Alert Type"
                                    id="alertSelect"
                                    options={alertType}
                                    selectedValues={selectedAlertType}
                                    onChange={setSelectedAlertType}
                                />
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12 text-end">
                                    <button
                                        type="button"
                                        className="btn "
                                        onClick={() => getAlertDetailsData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div
                    className="col-sm-12 card-alerts my-2 p-2 border-0  text-start no-radius"
                    style={{ width: '100%', position: 'relative' }}>
                    <div className="row mb-1">
                        <div className="col-12 d-flex justify-content-end gap-3 flex-wrap">
                            <div className="d-flex border px-3 py-2 align-items-center">
                                <strong className="me-2">Predictive</strong>
                                <span>{predectiveCount}</span>
                            </div>

                            <div className="d-flex border px-3 py-2 align-items-center">
                                <strong className="me-2">Failure</strong>
                                <span>{failureCount}</span>
                            </div>

                            <div className="d-flex border px-3 py-2 align-items-center">
                                <strong className="me-2">Total</strong>
                                <span>{totalsCount}</span>
                            </div>
                        </div>
                    </div>

                    <Table
                        columns={alertLiveColumns}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={showFeedbackModal}
                dialogClassName="modal-small-width"
                size="sm"
                onHide={feedbackCloseModalWithHeaderClass}>
                <Modal.Header closeButton className="modal-colored-header bg-primary">
                    <h4 className="modal-title text-light">
                        {/* {t('Feedback')} {notificationData?.device_name + ' (' + notificationData?.name + ')'} */}
                        {t('Feedback')}{' '}
                        {notificationData?.device_name && notificationData?.name
                            ? `${notificationData.device_name} (${notificationData.name})`
                            : ''}
                    </h4>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <AlertFeedbackModal
                                status={selectedStatus}
                                archievesId={notificationData?.archive_id}
                                masterId={notificationData?.master_id}
                                stationId={notificationData?.station_id}
                                notificationId={notificationData?.mango_notification_id}
                                alertMaintenance={notificationData?.alert_maintenance}
                                onHide={feedbackCloseModalWithHeaderClass}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer />
            </Modal>
        </>
    );
};

export default AlertLive;
